import { Button } from '@/components';
import s from './SuccessPopup.module.scss';

interface Props {
  onClose: () => void;
  title?: string;
  text?: string;
}

export const SuccessPopup = ({ onClose, title, text }: Props) => {
  return (
    <div className={s.modal}>
      <h2 className={s.notificationTitle}>{title || 'Ваша заявка принята'}</h2>
      <p className={s.notification}>
        {text || 'В ближайшее время с вами свяжется наш специалист для уточнения деталей. Пожалуйста, ожидайте звонка.'}
      </p>
      <div className={s.btnConfirm}>
        <Button
          name="Продолжить"
          theme="primary"
          onClick={onClose}
          size="block"
        />
      </div>
    </div>
  );
};